import { ListDataType } from '@features/files/types';

export const dataFormatterListDataTypeToPercent = (number: ListDataType) =>
  !number ? `${Number(0).toFixed(1)}%` : `${number}%`;
